import { useEffect } from "react";

// Authentication layout components
import IllustrationLayout from "../components";
import { useAuth0 } from "@auth0/auth0-react";
import useSocketUserDisconnect from "hooks/useSocketUserDisconnect";
// import { Tab1, Tab2, Tab3, Tab4 } from "./components/tabs";

// Image

function DbWaitingPage() {
	const { logout } = useAuth0(); // Get the logout function from Auth0
	const { userDisconnect } = useSocketUserDisconnect();

	const currentUrl = window.location.protocol + "//" + window.location.host;

	useEffect(() => {
		const timeout = setTimeout(() => {
			userDisconnect();
			logout({
				logoutParams: {
					returnTo: currentUrl + "/authentication/sign-in"
				}
			});
		}, 300000); // 5 minutes = 300,000 milliseconds
		// 20 sec = 20000

		return () => {
			clearTimeout(timeout); // Clear the timeout if the component unmounts before the timeout is reached
		};
	}, [logout]);

	return (
		<IllustrationLayout
			title="Hang in there!"
			description="We are now creating your database."
			forButton="Come back in a few minutes"
		>
			<div
				id="fff"
				style={{ display: "none" }}
			></div>

			<div
				id="fffd"
				style={{ position: "relative", top: "-50px" }}
			></div>
		</IllustrationLayout>
	);
}

export default DbWaitingPage;
